/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    B2cUser,
    B2cUserFromJSON,
    B2cUserFromJSONTyped,
    B2cUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface B2cUsersResult
 */
export interface B2cUsersResult {
    /**
     * 
     * @type {Array<B2cUser>}
     * @memberof B2cUsersResult
     */
    users?: Array<B2cUser> | null;
    /**
     * 
     * @type {string}
     * @memberof B2cUsersResult
     */
    skipToken?: string | null;
}

export function B2cUsersResultFromJSON(json: any): B2cUsersResult {
    return B2cUsersResultFromJSONTyped(json, false);
}

export function B2cUsersResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2cUsersResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': !exists(json, 'users') ? undefined : (json['users'] === null ? null : (json['users'] as Array<any>).map(B2cUserFromJSON)),
        'skipToken': !exists(json, 'skipToken') ? undefined : json['skipToken'],
    };
}

export function B2cUsersResultToJSON(value?: B2cUsersResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': value.users === undefined ? undefined : (value.users === null ? null : (value.users as Array<any>).map(B2cUserToJSON)),
        'skipToken': value.skipToken,
    };
}


